<template>
  <div class="not-found">
    <h1>Tražena stranica nije pronađena :(</h1>
    <h3>404</h3>
    <a class="btn btn-primary btn--mod" href="/#/">
      Idi na početnu stranu
    </a>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.not-found {
  margin-top: 10%;
  text-align: center;
}
</style>
